import type { Agency } from '../types';

export const TERMS_ACCEPTANCE_VERSION = 'v1';

export const FRENCH_FIRST_LOGIN_TERMS = [
  "En accedant a cette plateforme, vous reconnaissez utiliser un outil logiciel standard mis a disposition en l'etat, sans garantie de continuite parfaite, d'absence d'erreur, d'absence d'interruption ou d'adequation a un besoin commercial particulier.",
  "Vous restez seul responsable de la saisie, de la verification, du controle, de l'export, de l'archivage et de la sauvegarde de vos donnees, documents, reservations, factures, montants, disponibilites, informations clients et operations internes.",
  "Nous ne prenons pas en charge les pertes de donnees, pertes d'exploitation, pertes de chiffre d'affaires, pertes de clients, pertes d'opportunites, pertes de reputation, erreurs comptables, erreurs de planification, double reservation, indisponibilite temporaire ou dommages indirects resultant de l'utilisation ou de l'impossibilite d'utiliser la plateforme.",
  "Vous acceptez que toute decision commerciale, operationnelle, administrative, fiscale ou contractuelle prise sur la base des informations affichees dans le systeme releve de votre seule responsabilite.",
  "Vous reconnaissez que la plateforme ne remplace ni vos controles internes, ni vos validations humaines, ni vos obligations legales, comptables, fiscales, contractuelles, sociales, techniques ou de conformite.",
  "En cas d'erreur de parametres, de mauvaise configuration, d'oubli de sauvegarde, de suppression, d'import incorrect, d'usage par un employe, d'acces non autorise ou de mauvaise interpretation des donnees, la responsabilite de verification et de remediation reste a la charge du compte agence.",
  "Vous devez mettre en place vos propres procedures de controle, sauvegarde, export regulier, gestion des acces, validation des donnees et continuites d'activite. Aucune responsabilite n'est assumee pour un manque de procedure interne ou de supervision locale.",
  "Si vous n'acceptez pas ces conditions, vous ne devez pas utiliser la plateforme."
];

export const getAgencyTermsKey = (agencyId: string) =>
  `agency_first_login_terms_${agencyId}_${TERMS_ACCEPTANCE_VERSION}`;

export const hasAcceptedAgencyTerms = (
  agencyOrId?: string | Agency | null,
  backendAccepted?: boolean | null
) => {
  if (typeof backendAccepted === 'boolean') {
    return backendAccepted;
  }

  if (agencyOrId && typeof agencyOrId === 'object') {
    if (agencyOrId.termsAcceptedVersion && agencyOrId.termsAcceptedVersion !== TERMS_ACCEPTANCE_VERSION) {
      return false;
    }

    if (typeof agencyOrId.termsAccepted === 'boolean') {
      return agencyOrId.termsAccepted;
    }

    if (agencyOrId.termsAcceptedAt) {
      return true;
    }

    agencyOrId = agencyOrId._id || null;
  }

  if (!agencyOrId) {
    return true;
  }

  return localStorage.getItem(getAgencyTermsKey(agencyOrId)) === 'accepted';
};

export const acceptAgencyTerms = (agencyId: string) => {
  localStorage.setItem(getAgencyTermsKey(agencyId), 'accepted');
};
